import moment from "moment"
import React from "react"
import { Badge, Card, Col, ListGroup, Row, Table } from "react-bootstrap"

export default function ConditionSatuSehat({
    getCondition,
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    🩺 Condition Info
                </Card.Header>
                <Card.Body className="p-0" style={{ height: '180px', overflowY: 'auto', overflowX: 'auto' }}>
                    <div style={{ minWidth: '600px' }}>
                        <Table
                            bordered
                            striped
                            responsive
                            size="sm"
                            className="mb-0 small"
                            style={{ minWidth: '600px' }}
                        >
                            <thead className="table-light text-center">
                                <tr>
                                    <th>#</th>
                                    <th>📝 Diagnosa</th>
                                    <th>📄 ICD-10</th>
                                    <th>📌 Status</th>
                                    <th>⏰ Dicatat</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getCondition?.entry?.length > 0 ? (
                                    getCondition.entry.map((item, idx) => {
                                        const res = item.resource;
                                        return (
                                            <tr key={idx}>
                                                <td className="text-center">{idx + 1}</td>
                                                <td>{res.code?.coding?.[0]?.display || '-'}</td>
                                                <td>{res.code?.coding?.[0]?.code || '-'}</td>
                                                <td className="text-center">
                                                    <Badge bg="success" className="text-uppercase small">
                                                        {res.clinicalStatus?.coding?.[0]?.display || '-'}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    {res.recordedDate
                                                        ? moment(res.recordedDate).format('DD MMM YYYY, HH:mm')
                                                        : '-'}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            Tidak ada data diagnosa
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}